import React from 'react';
import classNames from 'classnames';

import css from './StatusBadge.module.css';

/**
 * A round status pill for listings, offers, orders and payouts. The words carry the
 * meaning; the colour only backs them up. Tones: success, pending, warn, error, neutral.
 */
const StatusBadge = ({ tone = 'neutral', className, children }) => (
  <span className={classNames(css.root, css[tone] || css.neutral, className)}>
    <span className={css.dot} aria-hidden="true" />
    {children}
  </span>
);

export default StatusBadge;
